/*
 * @Author: yangliao
 * @Date: 2020-11-17 14:09:36
 * @LastEditTime: 2021-04-29 11:02:38
 * @LastEditors: yangliao
 * @Description: 业务相关接口
 * @FilePath: /netHallOfficialAccounts/src/api/business.js
 */
import request from '@/utils/service';
import serverconfig from "@/api/server.config";

/* 业务办理查询 */
export function selectBusHandlingPage(params) {
  return request({
    url: `/busHandling/selectBusHandlingPage`,
    method: 'post',
    data: params,
  });
}

/* 业务办理查询 */
export function selectBzBusHandlingPage(params) {
  return request({
    url: `/BzApply/selectBzApply`,
    method: 'post',
    data: params,
  });
}
/* 业务进度查询 */
export function selectBusHandlingProgess(id) {
  return request({
    url: `/busHandling/selectBusHandlingProgess/${id}`,
    method: 'get',
  });
}

/* 报装业务进度查询 */
export function selectBzBusHandlingProgess(id) {
  return request({
    url: `/BzApply/selectProgress/${id}/1`,
    method: 'get',
  });
}
/* 获取绑定表卡 */
export function selectAccount() {
  return request({
    url: `/busHandling/selectAccount`,
    method: 'get',
  });
}
/* 根据业务code查询用户须知 */
export function getCustReadingByCode(params) {
  return request({
    url: `/custReading/getCustReadingByCode`,
    method: 'post',
    data: params,
  });
}
/* 认证信息 */
export function selectWaterUserRel() {
  return request({
    url: `/busHandling/selectWaterUserRel`,
    method: 'get',
  });
}
/* 业务新增 */
export function addBusHandling(params) {
  return request({
    url: `/busHandling/addBusHandling`,
    method: 'post',
    data: params,
  });
}

/* 报装业务新增 */
export function addBzBusHandling(params) {
  return request({
    url: `/BzApply/bzsq`,
    method: 'post',
    data: params,
  });
}

/* 通过ID查询业务信息 */
export function selectBusHandlingById(id) {
  return request({
    url: `/busHandling/selectBusHandlingById/${id}`,
    method: 'get',
  });
}

/* 通过ID查询报装业务信息 */
export function selectBzBusHandlingById(id) {
  return request({
    url: `/BzApply/selectBzApplyDetail/${id}`,
    method: 'get',
  });
}
/* 业务修改 */
export function updateBusHandling(params) {
  return request({
    url: `/busHandling/updateBusHandling`,
    method: 'post',
    data: params,
  });
}

/* 报装业务修改 */
export function updateBzBusHandling(params) {
  return request({
    url: `BzApply/updataBzApply`,
    method: 'post',
    data: params,
  });
}

/* 业务取消 */
export function cancelReport(id) {
  return request({
    url: `/busHandling/cancelReport/${id}`,
    method: 'get',
  });
}

/* 报装业务取消 */
export function cancelBzReport(id) {
  return request({
    url: `/BzApply/cancelBzApply/${id}`,
    method: 'get',
  });
}

/* 业务验证 */
export function verification(params) {
  return request({
    url: `/busHandling/verification`,
    method: 'post',
    data: params,
  });
}
/* 业务办理用信息 */
export function selectHandUser(params) {
  return request({
    url: `/busHandling/selectHandUser?waterUserNo=${params}`,
    method: 'get',
  });
}
// /busHandling/isMaster

/* 户主验证 */
export function isMaster(params) {
  return request({
    url: `/busHandling/isMaster/${params}`,
    method: 'get',
  });
}

/* 获取营业厅信息 */
export function selectListPageForNetHall() {
  return request({
    url: `/WxBranchNetwork/list`,
    method: 'get',
  });
}

/* 获取报装附件列表 */
export function selectEnclosure(id) {
  return request({
    url: `/BzApply/selectEnclosure?bzId=${id}`,
    method: 'post',
  });
}

export function updatePaymentStatus(id) {
  return request({
    url: `/BzApply/updatePaymentStatus/${id}`,
    method: 'post'
  });
}

// 网厅报装缴费查询
export function netHallBzPayment(params) {
  return request({
    baseURL: serverconfig.BZ_URL,
    url: `/PaymentPlan/netHallBzPayment/${params}`,
    method: 'post'
  });
}

export function creOrder(params) {
  return request({
    baseURL: serverconfig.BZ_PAY_URL,
    url: `/netHallBzPay/creOrder`,
    method: 'post',
    data: params,
  });
}

// 网厅查询缴费记录
export function netHallList(params) {
  return request({
    baseURL: serverconfig.BZ_PAY_URL,
    url: `/PaymentRecord/netHallList/${params}`,
    method: 'post'
  });
}
